import { useExploreContext } from '../context/ExploreContext';

export default function useExplore() {
  return useExploreContext();
}
